import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import styles from './Contact.module.css';

function Contact() {
  const [showDemoPopup, setShowDemoPopup] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showContactSuccess, setShowContactSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [demoForm, setDemoForm] = useState({
    fullName: '',
    email: '',
    position: '',
    company: '',
    requirements: '',
    preferredDate: '', // Updated: Separated date field
    preferredTime: '', // Updated: Separated time field
    timezone: '' // Updated: Added timezone field
  });
  const [contactForm, setContactForm] = useState({
    fullName: '',
    email: '',
    message: ''
  });

  // EmailJS configuration
  const EMAILJS_SERVICE_ID = 'service_ag00jjj';
  const EMAILJS_PUBLIC_KEY = 'bboQmlHKCPOy5DyKg';
  
  // Template IDs for different forms
  const CONTACT_TEMPLATE_ID = 'template_contact_us';
  const DEMO_TEMPLATE_ID = 'template_demo_request';

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowError(false);
    setShowContactSuccess(false);

    try {
      const templateParams = {
        from_name: contactForm.fullName,
        from_email: contactForm.email,
        message: contactForm.message,
        to_email: 'samiksha3016@gmail.com'
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        CONTACT_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      setShowContactSuccess(true);
      setContactForm({ fullName: '', email: '', message: '' });
      
      setTimeout(() => {
        setShowContactSuccess(false);
      }, 5000);
    } catch (error) {
      console.error('EmailJS error:', error);
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDemoSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowError(false);
    setShowSuccessMessage(false);
    setFieldErrors({});

    // Validate required fields
    const errors = {};
    if (!demoForm.fullName || demoForm.fullName.trim() === '') {
      errors.fullName = 'Please enter your full name.';
    }
    if (!demoForm.email || demoForm.email.trim() === '') {
      errors.email = 'Please enter your email address.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(demoForm.email)) {
      errors.email = 'Please enter a valid email address.';
    }
    if (!demoForm.company || demoForm.company.trim() === '') {
      errors.company = 'Please enter your company or airport name.';
    }
    if (!demoForm.preferredTime || demoForm.preferredTime.trim() === '') {
      errors.preferredTime = 'Please select a preferred time.';
    }
    if (!demoForm.preferredDate || demoForm.preferredDate.trim() === '') {
      errors.preferredDate = 'Please select a preferred date.';
    }

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setIsLoading(false);
      return;
    }

    try {
      const templateParams = {
        from_name: demoForm.fullName,
        from_email: demoForm.email,
        position: demoForm.position,
        company: demoForm.company,
        requirements: demoForm.requirements,
        preferred_date: demoForm.preferredDate, // Updated: Separated date field
        preferred_time: demoForm.preferredTime, // Updated: Separated time field
        timezone: demoForm.timezone, // Updated: Added timezone to email template
        to_email: 'samiksha3016@gmail.com'
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        DEMO_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      setShowSuccessMessage(true);
      setDemoForm({
        fullName: '',
        email: '',
        position: '',
        company: '',
        requirements: '',
        preferredDate: '', // Updated: Separated date field
        preferredTime: '', // Updated: Separated time field
        timezone: '' // Updated: Added timezone to form reset
      });
      
      setTimeout(() => {
        setShowSuccessMessage(false);
        setShowDemoPopup(false);
      }, 5000);
    } catch (error) {
      console.error('EmailJS error:', error);
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDemoForm({
      ...demoForm,
      [name]: value
    });
    // Clear error for this field when user starts typing
    if (fieldErrors[name]) {
      setFieldErrors({
        ...fieldErrors,
        [name]: ''
      });
    }
  };

  const handleContactInputChange = (e) => {
    setContactForm({
      ...contactForm,
      [e.target.name]: e.target.value
    });
  };
  return (
    <section className={styles.section} id="contact">
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.leftSection}>
            <div className={styles.formCard} id="contact-us-form">
              <h2 className={styles.formTitle}>Contact Us</h2>
              <p className={styles.formSubtitle}>Get in touch with our team to discuss your airport's specific needs</p>
              
              <form onSubmit={handleContactSubmit}>
                <div className={styles.formGroup}>
                  <label className={styles.label} htmlFor="contactFullName">Full Name</label>
                  <input 
                    type="text" 
                    id="contactFullName"
                    name="fullName"
                    value={contactForm.fullName}
                    onChange={handleContactInputChange}
                    className={styles.input} 
                    placeholder="John Doe"
                    required
                  />
                </div>
                
                <div className={styles.formGroup}>
                  <label className={styles.label} htmlFor="contactEmail">Email Address</label>
                  <input 
                    type="email" 
                    id="contactEmail"
                    name="email"
                    value={contactForm.email}
                    onChange={handleContactInputChange}
                    className={styles.input} 
                    placeholder="john.doe@airport.com"
                    required
                  />
                </div>
                
                <div className={styles.formGroup}>
                  <label className={styles.label} htmlFor="contactMessage">Message</label>
                  <textarea 
                    id="contactMessage"
                    name="message"
                    value={contactForm.message}
                    onChange={handleContactInputChange}
                    className={`${styles.input} ${styles.textarea}`}
                    placeholder="Tell us about your airport's needs and challenges..."
                    required
                  />
                </div>
                
                <button type="submit" className={styles.submitBtn} disabled={isLoading}>
                  {isLoading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
              
              {showContactSuccess && (
                <div className={styles.successMessage}>
                  Thank you! We'll get back to you soon.
                </div>
              )}
              
              {showError && (
                <div className={styles.errorMessage}>
                  Oops, something went wrong. Please try again later.
                </div>
              )}
            </div>
          </div>

          <div className={styles.rightSection}>
            <div className={styles.demoCard}>
              <h2 className={styles.demoTitle}>Request a Demo</h2>
              <p className={styles.demoSubtitle}>Experience our AI solutions firsthand with a personalized demo:</p>
              
              <ul className={styles.features}>
                <li className={styles.feature}>
                  <span className={styles.checkIcon}>✓</span>
                  Live walkthrough of OpsAssist
                </li>
                <li className={styles.feature}>
                  <span className={styles.checkIcon}>✓</span>
                  Tailored discussion on how it can support your airport's operations
                </li>
                <li className={styles.feature}>
                  <span className={styles.checkIcon}>✓</span>
                  ROI insights and implementation roadmap
                </li>
                <li className={styles.feature}>
                  <span className={styles.checkIcon}>✓</span>
                  Q&A with our technical experts
                </li>
              </ul>
              
              <button 
                className={styles.demoBtn}
                onClick={() => {
                  setShowDemoPopup(true);
                  setFieldErrors({});
                }}
              >
                Schedule Demo
              </button>
            </div>

          </div>
        </div>
       </div>
       
       {/* Demo Popup */}
       {showDemoPopup && (
         <div className={styles.popupOverlay}>
           <div className={styles.popup}>
             <div className={styles.popupHeader}>
               <h3 className={styles.popupTitle}>Schedule a Demo</h3>
               <button 
                 className={styles.closeBtn}
                 onClick={() => {
                   setShowDemoPopup(false);
                   setFieldErrors({});
                 }}
               >
                 ×
               </button>
             </div>
             
             {showSuccessMessage ? (
               <div className={styles.successMessage}>
                 <div className={styles.successIcon}>✓</div>
                 <h4>Thank you!</h4>
                 <p>We've received your request to schedule a demo. Our team will get back to you with a confirmation.</p>
               </div>
             ) : (
               <form onSubmit={handleDemoSubmit} className={styles.popupForm}>
                 <div className={styles.formGroup}>
                   <label className={styles.label} htmlFor="popupFullName">
                     Full Name <span className={styles.required}>*</span>
                   </label>
                   <input 
                     type="text" 
                     id="popupFullName"
                     name="fullName"
                     value={demoForm.fullName}
                     onChange={handleInputChange}
                     className={`${styles.input} ${fieldErrors.fullName ? styles.inputError : ''}`} 
                     placeholder="John Doe"
                     required
                   />
                   {fieldErrors.fullName && (
                     <div className={styles.fieldError}>{fieldErrors.fullName}</div>
                   )}
                 </div>
                 
                 <div className={styles.formGroup}>
                   <label className={styles.label} htmlFor="popupEmail">
                     Email ID <span className={styles.required}>*</span>
                   </label>
                   <input 
                     type="email" 
                     id="popupEmail"
                     name="email"
                     value={demoForm.email}
                     onChange={handleInputChange}
                     className={`${styles.input} ${fieldErrors.email ? styles.inputError : ''}`} 
                     placeholder="john.doe@airport.com"
                     required
                   />
                   {fieldErrors.email && (
                     <div className={styles.fieldError}>{fieldErrors.email}</div>
                   )}
                 </div>
                 
                 <div className={styles.formGroup}>
                   <label className={styles.label} htmlFor="popupPosition">Position/Role</label>
                   <input 
                     type="text" 
                     id="popupPosition"
                     name="position"
                     value={demoForm.position}
                     onChange={handleInputChange}
                     className={styles.input} 
                     placeholder="Operations Manager"
                     required
                   />
                 </div>
                 
                 <div className={styles.formGroup}>
                   <label className={styles.label} htmlFor="popupCompany">
                     Airport / Company <span className={styles.required}>*</span>
                   </label>
                   <input 
                     type="text" 
                     id="popupCompany"
                     name="company"
                     value={demoForm.company}
                     onChange={handleInputChange}
                     className={`${styles.input} ${fieldErrors.company ? styles.inputError : ''}`} 
                     placeholder="International Airport Authority"
                     required
                   />
                   {fieldErrors.company && (
                     <div className={styles.fieldError}>{fieldErrors.company}</div>
                   )}
                 </div>
                 
                 <div className={styles.formGroup}>
                   <label className={styles.label} htmlFor="popupRequirements">Requirements/Notes</label>
                   <textarea 
                     id="popupRequirements"
                     name="requirements"
                     value={demoForm.requirements}
                     onChange={handleInputChange}
                     className={`${styles.input} ${styles.textarea}`}
                     placeholder="Tell us about your specific needs and challenges..."
                     rows="3"
                   />
                 </div>
                 
                 <div className={styles.formRow}> {/* Updated: Flex container for time and timezone */}
                   <div className={styles.formGroup}>
                     <label className={styles.label} htmlFor="popupTime">
                       Preferred Time <span className={styles.required}>*</span>
                     </label>
                     <input 
                       type="time" 
                       id="popupTime"
                       name="preferredTime"
                       value={demoForm.preferredTime}
                       onChange={handleInputChange}
                       className={`${styles.input} ${fieldErrors.preferredTime ? styles.inputError : ''}`}
                       required
                     />
                     {fieldErrors.preferredTime && (
                       <div className={styles.fieldError}>{fieldErrors.preferredTime}</div>
                     )}
                   </div>
                   
                   <div className={styles.formGroup}>
                     <label className={styles.label} htmlFor="popupTimezone">Timezone (GMT +X)</label>
                     <select 
                       id="popupTimezone"
                       name="timezone"
                       value={demoForm.timezone}
                       onChange={handleInputChange}
                       className={styles.input}
                       required
                     >
                       <option value="">Select your timezone</option>
                       <option value="GMT-12">GMT-12 (Baker Island)</option>
                       <option value="GMT-11">GMT-11 (American Samoa)</option>
                       <option value="GMT-10">GMT-10 (Hawaii)</option>
                       <option value="GMT-9">GMT-9 (Alaska)</option>
                       <option value="GMT-8">GMT-8 (Pacific Time)</option>
                       <option value="GMT-7">GMT-7 (Mountain Time)</option>
                       <option value="GMT-6">GMT-6 (Central Time)</option>
                       <option value="GMT-5">GMT-5 (Eastern Time)</option>
                       <option value="GMT-4">GMT-4 (Atlantic Time)</option>
                       <option value="GMT-3">GMT-3 (Brazil)</option>
                       <option value="GMT-2">GMT-2 (Mid-Atlantic)</option>
                       <option value="GMT-1">GMT-1 (Azores)</option>
                       <option value="GMT+0">GMT+0 (London)</option>
                       <option value="GMT+1">GMT+1 (Central Europe)</option>
                       <option value="GMT+2">GMT+2 (Eastern Europe)</option>
                       <option value="GMT+3">GMT+3 (Moscow)</option>
                       <option value="GMT+4">GMT+4 (Dubai)</option>
                       <option value="GMT+5">GMT+5 (Pakistan)</option>
                       <option value="GMT+5:30">GMT+5:30 (India)</option>
                       <option value="GMT+6">GMT+6 (Bangladesh)</option>
                       <option value="GMT+6:30">GMT+6:30 (Myanmar)</option>
                       <option value="GMT+7">GMT+7 (Thailand)</option>
                       <option value="GMT+8">GMT+8 (Singapore/Hong Kong)</option>
                       <option value="GMT+8:30">GMT+8:30 (North Korea)</option>
                       <option value="GMT+9">GMT+9 (Japan)</option>
                       <option value="GMT+9:30">GMT+9:30 (Australia Central)</option>
                       <option value="GMT+10">GMT+10 (Australia East)</option>
                       <option value="GMT+10:30">GMT+10:30 (Lord Howe Island)</option>
                       <option value="GMT+11">GMT+11 (Solomon Islands)</option>
                       <option value="GMT+12">GMT+12 (New Zealand)</option>
                       <option value="GMT+13">GMT+13 (Tonga)</option>
                       <option value="GMT+14">GMT+14 (Line Islands)</option>
                     </select>
                   </div>
                 </div> {/* Updated: Time and timezone on same line */}
                 
                 <div className={styles.formGroup}>
                   <label className={styles.label} htmlFor="popupDate">
                     Preferred Date <span className={styles.required}>*</span>
                   </label>
                   <input 
                     type="date" 
                     id="popupDate"
                     name="preferredDate"
                     value={demoForm.preferredDate}
                     onChange={handleInputChange}
                     className={`${styles.input} ${fieldErrors.preferredDate ? styles.inputError : ''}`}
                     required
                   />
                   {fieldErrors.preferredDate && (
                     <div className={styles.fieldError}>{fieldErrors.preferredDate}</div>
                   )}
                 </div> {/* Updated: Moved date after time */}
                 
                 <button type="submit" className={styles.submitBtn} disabled={isLoading}>
                   {isLoading ? 'Submitting...' : 'Submit Request'}
                 </button>
               </form>
             )}
             
             {showError && (
               <div className={styles.errorMessage}>
                 Oops, something went wrong. Please try again later.
               </div>
             )}
           </div>
         </div>
       )}
     </section>
   );
 }

export default Contact;
